import React,{useState,useContext} from 'react'

import styled from 'styled-components'
import 'bootstrap/dist/css/bootstrap.min.css';
import Dropdown from 'react-bootstrap/Dropdown';

import { FaBars, FaTimes } from 'react-icons/fa';
import { SidebarContext } from '../../context/sidebar';
import bannerImage from '../../images/png/2.png'

const HeaderEl = styled.header`

    display: flex;
    width: 100%;
    align-items: center;
    height: 90px;
    padding: 0.9rem;
    justify-content: space-between;

    h1{
        font-family: "Poppins";
        font-weight: 600;
        font-size: 1.9rem;
    }
    

    #dropdown-basic{
        font-family: "Poppins";
        font-weight: 500;
        color: black;
        font-size: 0.9rem;
        height: 45px;
        
        border-radius: 60px;
        border: none;
        border: 1.9px solid rgb(215, 215, 215);
        background-color: white;
    }

    #dropdown-basic > img {
        border: 1px solid black;
        width: 31px;
        margin-right: 0.7rem;
        height: 31px;
        border-radius: 100px;
    }


    @media screen and (max-width:720px){
        padding: 0rem;
        justify-content: center;

        .drop_down{
            display: none;
        }
    }


`
const ButtonSidebar = styled.button`
    border: none;
    margin: 0 auto;
    background-color: white;
    display: none;

    @media screen and (max-width:720px){
        display: block;
    }

`;

const Banner = styled.div`

    @media screen and (min-width:1800px){
        position: absolute;
    background-image: url(${bannerImage});
    background-position: center;
    top: 0;
    left:8%;
    width: 100%;
    height: 680px;
    background-size: 80%;

    }
    position: absolute;
    background-image: url(${bannerImage});
    background-position: center;
    background-position-y: 30%;
    top: 0;
    left:10%;
    background-size: 100%;
    width: 100%;
    height: 580px;



`

const Header = ({ name,financial,color,zIndex}) => {
    const {sidebarState,handleSidebar} = useContext(SidebarContext)

    const handleExit = () => {
        localStorage.clear()
        sessionStorage.clear()
        window.location.href="/"
    }
    
    return (
        <>
        {financial == true 
        
        ?
        <Banner/>    
        :
        <></>
        }
        <HeaderEl>
            <h1 style={{zIndex:zIndex,color:color}} >{name}</h1>

    

            <Dropdown className='drop_down'>
                <Dropdown.Toggle  id="dropdown-basic">
                    <img src={localStorage.getItem("@USER_PICTURE")} />
                    {localStorage.getItem("@USER_NAME")} &nbsp;&nbsp;&nbsp;
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleExit()}>Sair</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

        </HeaderEl>
        </>
    )
}

export default Header